module.exports = __webpack_public_path__ + "static/media/payment-taxlist-icon.08e8ed47.svg";